module.exports = __webpack_public_path__ + "static/media/vf_wblouse_core.3b970f84.svg";